import { type Item } from '@/models/restaurant/Item';
import { createApiResource } from '../api';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

export const itemApi = {...createApiResource<Item, string>('restaurant/items'),    
    list: async (locationId: string, search?: string): Promise<Item[]> => {
        let url;
        if (search) {
            url = `${BASE_URL}/restaurant/items?search=${encodeURIComponent(search)}`;
        }
        else {
            url = `${BASE_URL}/restaurant/items`;
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`,
                'x-location-id': locationId
            }
        });
        const data = await response.json();
        if (!response.ok) throw new HttpError(response.status, data);
        return await data;       
    }};

export const deviceApi = itemApi;
